var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "4 4 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6572 12.7168C14.7882 12.7168 16.5156 10.9893 16.5156 8.85839C16.5156 6.72746 14.7882 5 12.6572 5C10.5263 5 8.79883 6.72746 8.79883 8.85839C8.79883 10.9893 10.5263 12.7168 12.6572 12.7168Z",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8828 12.1895C15.7628 12.3596 16.5558 12.8317 17.1248 13.5242C17.6938 14.2168 18.0031 15.0863 17.9992 15.9826V19.0871H7.31445V15.9826C7.31745 15.1018 7.62266 14.2486 8.17908 13.5658C8.7355 12.883 9.66643 12.3312 10.5285 12.1504",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19389 11.8838C7.42995 11.8838 6 10.4333 6 8.64404C6 6.85478 7.42995 5.54297 9.19389 5.54297",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.543L5 17.4825V14.7865C5.00275 14.0244 5.24488 13.2864 5.68589 12.696C6.12691 12.1056 6.74007 11.6986 7.42283 11.543",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0014 11.8838C17.7654 11.8838 19.1953 10.4333 19.1953 8.64404C19.1953 6.85478 17.7654 5.54297 16.0014 5.54297",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1953 17.543L20.1953 17.4825V14.7865C20.1926 14.0244 19.9504 13.2864 19.5094 12.696C19.0684 12.1056 18.4552 11.6986 17.7725 11.543",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.226ccb41b536d3246ebd10ca687b8081.svg";
export { ForwardRef as ReactComponent };